<template>
  <div class="vs-collapse" :class="[type]"><slot /></div>
</template>

<script>
export default {
  name: "VsCollapse",
  props: {
    accordion: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "default",
    },
    openHover: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["change"],
  provide() {
    return {
      vsCollapse: this,
    };
  },
  data() {
    return {
      items: [],
    };
  },
  methods: {
    registerItem(item) {
      this.items.push(item);
    },
    unregisterItem(item) {
      const index = this.items.indexOf(item);
      if (index !== -1) this.items.splice(index, 1);
    },
    emitChange() {
      this.$emit("change");
    },
    closeAllItems(activeItem) {
      this.items.forEach((item) => {
        if (item !== activeItem) item.close();
      });
    },
  },
};
</script>
